import React from 'react';
import Driver from '../../../models/scoopm/Driver';
import DriversTable from './DriversTable';

export default function IncompleteApplications() {
  return <DriversTable title="Incomplete" filter={(driver: Driver) => !driver.status} />;
}
